import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  privacyPolicyEdit,
  settingsPrivacyPolicyView,
  termsConditionEdit,
  termsConditionsview,
} from "../../redux/actions/settingAction";
import { useDispatch } from "react-redux";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";
import { useNavigate } from "react-router-dom";
import back from "../../assets/back.svg";
import ChangeSaved from "../../components/popups/ChangeSaved";
import ErrorPopup from "../../components/popups/ErrorPopup";

const TermsConditionEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [termsConditionData, setTermsConditionData] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  useEffect(() => {
    dispatch(termsConditionsview(onViewSuccess, onViewError));
  }, []);

  const onViewSuccess = (data) => {
    console.log(data);
    setTermsConditionData(data.data.data);
  };

  const onViewError = (err) => {
    console.log(err);
  };

  const initialValues = {
    text: termsConditionData?.terms,
  };

  const validationSchema = Yup.object().shape({
    text: Yup.string().required("Required"),
  });

  const resetFunc = (setFieldValue) => {
    setFieldValue("text", "");
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ align: "" }],
    ],
  };

  const onSubmit = (values) => {
    dispatch(
      termsConditionEdit({ terms: values.text }, onEditSuccess, onEditError)
    );
    console.log(values);
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/settings");
  };

  const onEditSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    setShowSuccessMsg(data.data.message);
    const str1 = data.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg(str_modify1);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onEditError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <div className="setting-container m-5">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ setFieldValue, values }) => (
            <Form className="">
              <div className="search-container d-flex justify-content-between ">
                <div
                  className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                  onClick={() => navigate(-1)}
                >
                  <img src={back} alt="back_btn" />
                  <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                    BACK
                  </span>
                </div>
                <div className=" d-flex justify-content-between m-1 mb-2">
                  <AdminButton
                    background="#E7E5FF"
                    width="100px"
                    onClick={() => resetFunc(setFieldValue)}
                    type="button"
                  >
                    RESET
                  </AdminButton>
                  <AdminButton
                    background="#2AD3E7"
                    color="white"
                    width="100px"
                    type="submit"
                  >
                    <span className="m-2">SAVE</span>
                  </AdminButton>
                </div>
              </div>
              <div className="faq-form-width ms-4 my-4 ps-3 py-1">
                <div className="my-2 mb-4">
                  <div
                    className="faq-text-container"
                    style={{ borderRadius: "15px" }}
                  >
                    <Field name="text">
                      {({ field }) => (
                        <ReactQuill
                          value={field.value}
                          onChange={field.onChange(field.name)}
                          modules={modules}
                          style={{
                            maxHeight: "400px",
                            height: "60vh",
                            borderRadius: "15px",
                          }}
                          className={"quill"}
                          placeholder={"Enter privacy policy here"}
                        />
                      )}
                    </Field>
                  </div>
                  <ErrorMsg name={"text"} />
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <ChangeSaved show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default TermsConditionEdit;
